<template>
	<span style="display:flex">
	   <a-form-model-item>
	      <downloadexcel
	      	class="ant-btn ant-btn-primary export-btn"
		:fetch="getdatasource"
		:fields="excelheader"
		:before-finish="exportsuccess"
		name="本页数据.xls"
	      >导出本页数据</downloadexcel>
	   </a-form-model-item>
	   <a-form-model-item>
	      <downloadexcel
	      	class="ant-btn ant-btn-primary export-btn"
		    :fields="excelheader"
			:fetch="getAllData"
			:before-finish="exportsuccess"
			name="全部数据.xls"
	      >导出全部数据</downloadexcel>
	   </a-form-model-item>
	</span>
</template>
<script>
import downloadexcel from "vue-json-excel";
import {message} from "ant-design-vue"
import {exportall} from "@/api/baogongzhangdan.js"
const  excelheader ={
	"开始时间":"starttime",
	"结束时间":"endtime",
	"身份证号码":{
		field:"idcard",
		callback:(val)=>{
			return `&nbsp; ${val}`
		}
		},
	"姓名":"name",
	"银行卡号":{
		field:"banknum",
		callback:(val)=>{
			return `&nbsp; ${val}`
		}
	},
	"所属班组":"group",
	"应付金额":"yingfu",
	"预支金额":"kouyuzhi",
	"结余金额":"jieyu",
	"是否发放":{
		field:"shifufafang",
		callback:(val)=>{
			if(val == 0){
				return "未发放"
			}else{
				return "已发放"
			}
		}
	},
}


// let user = sessionStorage.getItem("userinfo")
// user = JSON.parse(user)
export default {
	components:{
           downloadexcel
	},
	props:[
	    "tref",
	],
	data(){
		return {
		    excelheader,
			workplaceArray:[],
		}
	},
	methods:{
		// getworkpalceArrary(){
		// 	getAll({cmpid:user.cmpid}).then(ret=>{
		// 		if(ret.code == 0){
		// 			let {data} = ret
		// 			this.workplaceArray = data
		// 		}
		// 	})
		// },
    getdatasource(){
	      message.loading({content:"正在导出",key:"daochu"})
	      return this.tref.getDataSource()
	},
	exportsuccess(){
            message.success({content:"导出成功",key:"daochu",duration:2})
	},
	getall(){
		console.log({...this.searchData},this.tref.getsearchparm())
	},
	async getAllData(){
        message.loading({content:"正在导出",key:"daochu"})
	    let parm = this.tref.getsearchparm()
	    let {code,data} = await exportall(parm)
	    if(code == 0){
		    return data
	    }
	    return false
	},
	},
	// mounted(){
	// 	this.getworkpalceArrary()
	// }
}
</script>
<style lang="less" scoped>
    .export-btn{
	    line-height: 30px ;
    }
</style>



